import React from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

const options = [
  { label: 'Linux', value: 'Linux' },
  { label: 'Windows', value: 'Windows' },
  { label: 'Other', value: 'Other' },
]

interface Props {}

export default function OsPicklist({
  name = 'osType',
  label = 'Operating System',
  compact = false,
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  return <AsyncDropdown compact={compact} name={name} label={label} items={options} {...rest} />
}
